module.exports = __webpack_public_path__ + "static/media/darren-coleshill.46fe8377.jpg";